import React from 'react';
import { SalesPage } from './pages/SalesPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { NavigationProvider, useNavigation } from './context/NavigationContext';
function AppContent() {
  const {
    currentPage
  } = useNavigation();
  switch (currentPage) {
    case 'terms':
      return <TermsPage data-id="element-0" />;
    case 'privacy':
      return <PrivacyPage data-id="element-1" />;
    case 'home':
    default:
      return <SalesPage data-id="element-2" />;
  }
}
export function App() {
  return <NavigationProvider data-id="element-3">
      <AppContent data-id="element-4" />
    </NavigationProvider>;
}